import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function ScooterSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("scooter.title")}</title>
        <meta name="keywords" content={t("scooter.keywords")} />
        <meta name="description" content={t("scooter.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1e2a3d]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/scooter-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_11%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#121c2a]/92 via-[#121c2a]/72 to-[#121c2a]/62" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("scooter.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("scooter.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("scooter.knowledgeBase.rootLabel")}
        rootColor="#2563eb"
        treeTranslationKey="scooter.knowledgeBase.tree"
        i18nPrefix="scooter.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="scooter"
        images={{
          painPoints: "/solutions/scooter-pain.jpeg",
          solutions: "/solutions/scooter-solutions.jpeg",
          cta: "/solutions/scooter-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 24%",
          solutions: "50% 28%",
          cta: "50% 20%",
        }}
      />
    </>
  );
}
